export default function objectToFormData(object) {
  let formData = new FormData();
  for (var key in object) {
    formData.append(key, object[key]);
  }
  return formData;
}
